var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_setup.t('e_service_center.widget_info_text.care_overview_health_indicators'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }